const RelatedPolicyStyles = {
  heading: {
    color: "#1D252B",
    fontSize: "18px",
    fontFamily: "Noto Sans",
    fontWeight: "300",
    whiteSpace: "wrap",
    "@media(max-width:599px)": {
      fontSize: "14px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontFamily: "Noto Sans",
    },
    "@media (min-width: 1025px) and (max-width: 1366px)": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  content: {
    overflow: "hidden",
    color: "#1D252B",
    fontSize: "18px",
    fontFamily: "Noto Sans",
    fontWeight: "400",
    textOverflow: "ellipsis",
    "@media (max-width:768px)": {
      fontSize: "14px",
    },
  },
};
export default RelatedPolicyStyles;
